import { render, staticRenderFns } from "./EmployeePersonalDetailForm.vue?vue&type=template&id=4532becb&scoped=true&"
import script from "./EmployeePersonalDetailForm.vue?vue&type=script&lang=js&"
export * from "./EmployeePersonalDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4532becb",
  null
  
)

export default component.exports